import React, {useEffect} from 'react';

import {setDefaultOptions} from 'date-fns';
import moment from 'moment';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
// i18n support
import {IntlProvider} from 'react-intl';
import {connect} from 'react-redux';

import {getAdminLanguage} from '../state/auth/languageSelector';
import '../utils/i18n';
import {
  dateFnsLocaleMap,
  getLocalisedStringsForLanguage,
} from '../utils/language';

import styles from './styles.module.scss';

const LanguageView = ({language, children}) => {
  const messages = getLocalisedStringsForLanguage(language);

  useEffect(() => {
    // Set the document language for screen readers etc.
    document.documentElement.setAttribute('lang', language);
  });

  useEffect(() => {
    const setDefaultLocale = async () => {
      const locale = (await dateFnsLocaleMap[language]()).default;
      setDefaultOptions({locale});
    };

    setDefaultLocale();
  }, [language]);

  // this should be the only place where the global moment locale is changed
  moment.locale([language, 'en']); // fallback to english if requested locale not available

  return (
    <IntlProvider locale={language} messages={messages}>
      <div styleName='outerContainer'>
        <div>
          <div id='modalContainer' />
          <div id='nestedModalContainer' />
          <div id='nestedNestedModalContainer' />
        </div>
        {children}
      </div>
    </IntlProvider>
  );
};

LanguageView.propTypes = {
  language: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  language: getAdminLanguage(state),
});

export default connect(mapStateToProps)(
  CSSModules(LanguageView, styles, {allowMultiple: true})
);
